import {
  mapPaymentModuleNameToModuleId,
  type PaymentModuleId,
} from '@foundation/apis/payments';
import { isValidTheme, Theme } from '@pmi.web/react-theme';

import { IPaymentIntent, PaymentIntentFlow } from '@/schemas/PaymentIntent';

import { InvalidFlowError } from '../errors/InvalidFlowError';
import { ApiPaymentIntent } from '../schemas/ApiPaymentIntent';

export function parseApiPaymentIntent(
  intent: ApiPaymentIntent,
): IPaymentIntent {
  return {
    ...intent,
    customer: {
      ...intent.customer,
      flow: parseFlow(intent.customer.flow),
      theme: isValidTheme(intent.customer.theme)
        ? intent.customer.theme
        : Theme.PM,
      allowedPaymentMethods: parsePaymentMethods(
        intent.customer.allowedPaymentMethods ?? [],
      ),
      preSelectedPaymentMethod: mapPaymentModuleNameToModuleId(
        intent.customer.preSelectedPaymentMethod,
      ),
      skip3DS: intent.customer.skip3DS,
    },
  };
}

function parseFlow(flow: string): PaymentIntentFlow {
  if (Object.values(PaymentIntentFlow).includes(flow as PaymentIntentFlow)) {
    return flow as PaymentIntentFlow;
  }

  throw new InvalidFlowError(flow);
}

export function parsePaymentMethods(
  methods: ReadonlyArray<string>,
): ReadonlyArray<PaymentModuleId> {
  return methods
    .map((m) => {
      return mapPaymentModuleNameToModuleId(m);
    })
    .filter((x) => x !== undefined) as PaymentModuleId[];
}
